import React from 'react'
import CommonHeader from './CommonHeader';
import './_scrolltopnavbar.scss';

/**
 * Header for the mock test, videos, notes, bookmarks, college predictor, ...
 * pages: the shared CommonHeader bar, in the page's own colour. Thin wrapper
 * that keeps the props pages already pass:
 *   onClick       sidebar toggle
 *   headerBottom  { type, title } or { Title, ... }; its title becomes the
 *                 page title in the bar
 *   color, tone   header colour (default: a colour of its own per page)
 */
function ScrollTopNavbar({ onClick, headerBottom = {}, color = "auto", tone = "light" }) {
    const type = headerBottom.type;
    return (
        <CommonHeader
            className="scroll-header"
            color={color}
            tone={tone}
            onToggleSidebar={onClick}
            back={type == "Exam_pattern" || type == "Quiz_Exam"}
            title={headerBottom.title || headerBottom.Title}
        />
    );
}

export default ScrollTopNavbar;
